/**
 * @module websocket.event.handlers.bookings.booking-updated
 */
import { store } from '../../../../state/store'
import { setBookingItemUpdated } from '../../../../state/websocket.slice'

export default function handleBookingUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBookingUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBookingItemUpdated(data))
  }
} 